import React from 'react';
import { Field, Section, Toggle, patchSection } from './shared';

export default function AbandonTab({ schema, onChange }) {
  const minutes = schema.abandonment?.minutes ?? 30;
  const consent = schema.consent || {};
  const invalid = !(Number(minutes) >= 5 && Number(minutes) <= 1440);

  return (
    <div className="space-y-4">
      <Section title="Abandono">
        <Field label="Considerar abandonado após (minutos)" hint="Entre 5 e 1440 (24 horas). Sessões identificáveis (com telefone ou e-mail) sem atividade por esse tempo são marcadas como abandonadas e enviadas por webhook.">
          <input
            className="input max-w-[160px]" type="number" min={5} max={1440} value={minutes}
            onChange={(e) => onChange(patchSection(schema, 'abandonment', { minutes: e.target.value === '' ? '' : Number(e.target.value) }))}
          />
          {invalid && <p className="text-xs text-red-600 mt-1">Informe um valor entre 5 e 1440.</p>}
        </Field>
      </Section>
      <Section title="Consentimento">
        <Toggle
          checked={consent.requiredBeforePartial === true}
          onChange={(v) => onChange(patchSection(schema, 'consent', { requiredBeforePartial: v }))}
          label="Só salvar respostas parciais após o consentimento do visitante"
        />
      </Section>
    </div>
  );
}
